export const MICROSITE_PRIVACY_LANGUAGES = [
	'EnUs',
	'EnUk',
	'EnAu',
	'EnNz',
	'EnHk',
	'ZhHk',
	'InIn',
	'JaJp',
	'EnMy',
	'MsMs',
	'EnSg',
	'ZhTw',
	'ThTh',
	'KoKr',
	'CsCz',
	'DaDk',
	'DeAt',
	'DeCh',
	'DeDe',
	'ElGr',
	'EnHi',
	'EnZa',
	'EsEs',
	'FiFi',
	'FrBe',
	'FrCh',
	'FrFr',
	'HeIl',
	'HiHi',
	'HuHu',
	'ItIt',
	'NlBe',
	'NlNl',
	'NoNo',
	'PlPl',
	'PtPt',
	'RoRo',
	'SvSe',
	'TrTr',
];

export const getMicrositePrivacyCheckboxCount = (language: string) => {
	if (language === 'EnUs' || language === 'KoKr') return 2;
	if (['InIn', 'EnMy', 'MsMs', 'ThTh'].includes(language)) return 1;
	return 0;
};

export const hasMicrositePrivacy = (isMicrosite: boolean, language: string) =>
	isMicrosite && MICROSITE_PRIVACY_LANGUAGES.includes(language);
